import { filter } from 'rxjs/operators';

// tslint:disable-next-line:typedef
export function isTruthy<T>() {
  return filter<T>(item => !!item);
}
